/**
 * 语言切换器 - 按钮组形式
 * 横向排列所有语言选项
 */

import { useTranslation } from '../../useTranslation';
import { useLanguageNavigation } from '../../hooks/useLanguageNavigation';
import type { SizeClasses } from './types';

interface ButtonGroupProps {
  sizeClasses: SizeClasses;
  className?: string;
}

export function ButtonGroup({ sizeClasses, className = '' }: ButtonGroupProps) {
  const { language, availableLanguages } = useTranslation();
  const { changeLanguage } = useLanguageNavigation();

  // 语言代码简写映射
  const langLabel: Record<string, string> = {
    'zh-CN': '中',
    ja: '日',
    en: 'En',
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {availableLanguages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code as import('../../types').ActiveLanguage)}
          className={`
            rounded-lg transition-all duration-200
            ${sizeClasses.md}
            ${language === lang.code
              ? 'bg-[var(--y-accent)] text-[var(--y-text-primary)] font-medium'
              : 'text-[var(--y-text-tertiary)] hover:text-[var(--y-text-primary)] hover:bg-[var(--y-surface-secondary)]'
            }
          `}
          aria-label={lang.nativeName}
          aria-pressed={language === lang.code}
        >
          <span className="mr-1">{lang.flag}</span>
          <span>{langLabel[lang.code] || lang.code}</span>
        </button>
      ))}
    </div>
  );
}
